
import DOMPurify from 'dompurify';

export const sanitizeHtml = (html: string): string => {
  if (!html) return '';
  
  // Configure DOMPurify to allow safe HTML tags and attributes
  const config = {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'blockquote', 'a', 'img', 'code', 'pre'
    ],
    ALLOWED_ATTR: [
      'href', 'src', 'alt', 'title', 'target', 'rel'
    ],
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  };
  
  return DOMPurify.sanitize(html, config);
};

export const sanitizeInput = (input: string): string => {
  if (!input) return '';
  
  // Remove any HTML tags from plain text inputs
  return input.replace(/<[^>]*>/g, '').trim();
};

export const validateTitle = (title: string): { isValid: boolean; error?: string } => {
  const sanitized = sanitizeInput(title);
  
  if (!sanitized) {
    return { isValid: false, error: "Title is required" };
  }
  
  if (sanitized.length > 200) {
    return { isValid: false, error: "Title must be less than 200 characters" };
  }
  
  return { isValid: true };
};

export const validatePassword = (password: string): { isValid: boolean; error?: string } => {
  if (!password) return { isValid: true }; // Password is optional
  
  const sanitized = sanitizeInput(password);
  
  if (sanitized.length < 4) {
    return { isValid: false, error: "Password must be at least 4 characters" };
  }
  
  if (sanitized.length > 50) {
    return { isValid: false, error: "Password must be less than 50 characters" };
  }
  
  return { isValid: true };
};
